import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../utilities/TabGrid";
import {
    TopButtonAction,
    TopButtonPointAction,
} from "../../../../../componentsTopsa/buttons/TopButtons";


export default class EbusLogiTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            szczegoly: null
        };
        this.renderButtonyAkcji=this.renderButtonyAkcji.bind(this)
    }

    componentDidMount() {
    }

    renderButtonyAkcji(cell,row){
        return(
            <div>
                <TopButtonPointAction buttonIcon={'fa fa-eye'}
                                      disabled={!Boolean(row.dane)}
                                      onClick={()=>{
                                          console.log((row.dane));
                                          this.setState({
                                          showModal: true,
                                          szczegoly: row.dane
                                      })}}
                                      titleContent={'Zobacz dokładne logi'} />
            </div>
        )
    }

    formatTyp(cell,row){
        if(cell === 'INFO'){
            return <span className={'label label-info'} style={{}}>{cell}</span>
        }
        else if(cell === 'DEBUG'){
            return <span className={'label label-warning'} style={{}}>{cell}</span>
        }
        else if(cell === 'ERROR'){
            return <span className={'label label-danger'} style={{}}>{cell}</span>
        }
        else return cell
    }

    render() {
        const options = {
            sizePerPageList: [10, 15, 30,50,100],
            noDataText: 'Brak pasujących rekordów',
            sizePerPage: this.props.ilosc,
            page: this.props.strona,
            onSizePerPageList: this.props.onSizePerPageList,
            onPageChange: this.props.onPageChange,
        };

        return (
            <div>
                <div>
                    <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                        Ilość wszystkich logów: {Boolean(this.props.pageable.totalElements) ? this.props.pageable.totalElements : 0}
                    </div>
                    <div>
                        <BootstrapTable data={this.props.data}
                                        options={options}
                                        pagination
                                        hover
                                        fetchInfo={{dataTotalSize: this.props.pageable.totalElements}}
                                        remote={true}
                        >
                            <TableHeaderColumn dataField='id' isKey hidden={false} thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}} dataSort
                                               headerText={"id"}
                            >id
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='data_wpisu'  dataSort
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell.replace('T',' ').substr(0,16)}</span>}}
                                               headerText={"data_wpisu"}
                            >data_wpisu</TableHeaderColumn>
                            <TableHeaderColumn dataField='url'  dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={(cell,row)=>{return <div style={{fontSize:'12px', maxWidth:'250px',wordBreak:'break-all'}}>{cell}</div>}}
                                               headerText={"url"}
                            >url</TableHeaderColumn>
                            <TableHeaderColumn dataField='typ'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={this.formatTyp}
                                               headerText={"typ"}
                            >typ</TableHeaderColumn>
                            <TableHeaderColumn dataField='metoda'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                                               headerText={"metoda"}
                            >metoda</TableHeaderColumn>
                            <TableHeaderColumn dataField='event'  dataSort
                                               thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                               dataFormat={(cell,row)=>{return <div style={{fontSize:'12px', maxWidth:'250px',wordBreak:'break-all'}}>{cell}</div>}}
                                               headerText={"event"}
                            >event</TableHeaderColumn>
                            <TableHeaderColumn dataField='opis'  dataSort
                                               thStyle={tabgrid. tg3} tdStyle={tabgrid. tg3}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}>{cell}</span>}}
                                               headerText={"opis"}
                            >opis</TableHeaderColumn>
                            <TableHeaderColumn dataField='id_ku'  dataSort
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={(cell,row)=>{return <span className={"label label-ebus-default"}>{cell}</span>}}
                                               headerText={"id_ku"}
                            >id_ku</TableHeaderColumn>
                            <TableHeaderColumn dataField='login'  dataSort
                                               thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'12px'}}><span style={{fontSize:'10px'}}>[{row.id_uz}]</span> {cell}</span>}}
                                               headerText={"login , id_uz"}
                            >[id_uz] login</TableHeaderColumn>
                            <TableHeaderColumn dataField='klient_ip'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'10px'}}>{cell}</span>}}
                                               headerText={"klient_ip"}
                            >klient_ip</TableHeaderColumn>
                            <TableHeaderColumn dataField='klient_info'  dataSort
                                               thStyle={tabgrid. tg1} tdStyle={tabgrid. tg1}
                                               dataFormat={(cell,row)=>{return <span style={{fontSize:'10px'}}>{cell}</span>}}
                                               headerText={"klient_info"}
                            >klient_info</TableHeaderColumn>
                            <TableHeaderColumn dataField='id'
                                               thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                               dataFormat={this.renderButtonyAkcji}
                            >Zobacz</TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
                {
                    Boolean(this.state.szczegoly) && this.state.showModal?
                        <div id={'EBUSModalContainerBG'}>
                            <div id={'modalContainer'}>
                                <div id={'modalTextContent'} style={{width: '1000px'}}>
                                    <div>
                                        <div className={'pull-right'}>
                                            <TopButtonAction onClick={() => {
                                                this.setState({showModal: false, szczegoly: null})
                                            }}
                                                             elementStyle={{color: 'firebrick'}}
                                                             btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                            />
                                        </div>
                                        <div style={{clear: 'both', height:'5px'}}></div>
                                        <div>
                                            <div className={'thumbnail'} style={{maxWidth:'966px', maxHeight:'450px'}}>
                                                <div style={{padding:'5px', fontFamily:'monospace', overflow:'auto', maxHeight:"400px"}}>
                                                    {(this.state.szczegoly)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{clear: 'both'}}></div>
                            </div>
                        </div>
                        :
                        ''
                }


            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/logi/ebusTab/components/EbusLogiTable.js